export const SET_PAGE = 'SET_PAGE';
export const SET_ROWS = 'SET_ROWS';
export const SET_SIDEBAR = 'SET_SIDEBAR';
